import { Button, Row } from '@components'
import theme from '@utils/theme'
import { useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { Fragment } from 'react/jsx-runtime'

export interface IOrderFilter {
  title: string
  key: 'Self' | 'Pending' | 'Lend' | 'Return' | 'Driver Assigned'
  bg: keyof typeof theme.colors
  tc: keyof typeof theme.colors
}

interface IOrderManagementFilter {
  onChangeFilter: (filter: IOrderFilter['key']) => void
  activeKey?: IOrderFilter['key']
}

const filters: IOrderFilter[] = [
  { title: 'Self Order', key: 'Self', bg: 'primary50', tc: 'primary' },
  { title: 'Pending', key: 'Pending', bg: 'redLight', tc: 'redNormal' },
  {
    title: 'Driver Assigned',
    key: 'Driver Assigned',
    bg: 'primary50',
    tc: 'primary',
  },
  { title: 'Book Lend', key: 'Lend', bg: 'yellowLight', tc: 'yellowNormal' },
  {
    title: 'Book Return',
    key: 'Return',
    bg: 'tabGreenLight',
    tc: 'tabGreenNormal',
  },
]
export const validKeys: IOrderFilter['key'][] = [
  'Self',
  'Pending',
  'Lend',
  'Return',
  'Driver Assigned',
]

const OrderManagementFilter = ({
  onChangeFilter,
  activeKey,
}: IOrderManagementFilter) => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()

  const tab =
    (validKeys.includes(searchParams.get('tab') as IOrderFilter['key'])
      ? (searchParams.get('tab') as IOrderFilter['key'])
      : activeKey) || 'Self'

  const [activeFilter, setActiveFilter] = useState<IOrderFilter['key']>(tab)

  const handleTabChange = (key: IOrderFilter['key']) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('tab', key)

    setActiveFilter(key)
    onChangeFilter(key)

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      state: location.state,
    })
  }

  return (
    <Fragment>
      <Row colGap={20}>
        {filters.map((filter) => (
          <Button
            title={filter.title}
            key={filter.key}
            bg={filter.bg}
            tc={filter.tc}
            border={activeFilter === filter.key ? filter.tc : 'grey100'}
            onClick={() => handleTabChange(filter.key)}
          />
        ))}
      </Row>
    </Fragment>
  )
}

export default OrderManagementFilter
